export default "__VITE_ASSET__Dn8IqOhI__"